
export const environment = {
  production: true,
  OSRTCAPIURL :'https://master.osrtc.org/mdbapi/api/WebPortalAPI',
  OSRTCDOCUMENTURL :'https://master.osrtc.org/mdbapi/',
  OPRSAPIURL:'https://counter.osrtc.org/oprsapi/api',
  OPRSURL:' https://booking.osrtc.org/#/',
  CounterURL:'https://counter.osrtc.org/'
  //OPRSURL:' https://osrtcliveoprs.amnex.com/commuterweb/#/',
  //CounterURL:'https://osrtcliveoprs.amnex.com/counterweb/'
};
